import Header from '../Header'
import HomeRoute from '../HomeRoute'
import Footer from '../Footer'

const Home = () => (
  <>
    <Header />
    <HomeRoute />
    <Footer />
  </>
)

export default Home
